import {useCallback, useState} from "react";

import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IOfferBuilding} from "../offer/detail/types/IOfferBuilding";

export const useOfferBuildings = () => {
    const [offerBuildings, setOfferBuildings] = useState<IOfferBuilding[] | null>(null);

    const fetchOfferBuildings = useCallback((offerId: number | undefined) => {
        /**
         * Fetch offer buildings, when map view is opened for the first time.
         */
        if (offerId && !offerBuildings) {
            const requestUrl = appendQueryString(apiV2ListLink.buildings.list(Scenario.BUILDING_PLAN), {offer: offerId});

            getRequest({}, requestUrl)
                .then((response) => {
                    setOfferBuildings(response.results);
                })
                .catch(() => {
                    setOfferBuildings(null);
                });
        }
    }, []);

    return {
        offerBuildings: offerBuildings as IOfferBuilding[],
        fetchOfferBuildings
    };
};
import {useCallback, useState} from "react";

import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IOfferBuilding} from "../offer/detail/types/IOfferBuilding";

export const useOfferBuildings = () => {
    const [offerBuildings, setOfferBuildings] = useState<IOfferBuilding[] | null>(null);

    const fetchOfferBuildings = useCallback((offerId: number | undefined) => {
        /**
         * Fetch offer buildings, when map view is opened for the first time.
         */
        if (offerId && !offerBuildings) {
            const requestUrl = appendQueryString(apiV2ListLink.buildings.list(Scenario.BUILDING_PLAN), {offer: offerId});

            getRequest({}, requestUrl)
                .then((response) => {
                    setOfferBuildings(response.results);
                })
                .catch(() => {
                    setOfferBuildings(null);
                });
        }
    }, []);

    return {
        offerBuildings: offerBuildings as IOfferBuilding[],
        fetchOfferBuildings
    };
};
